export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: that.disabled ? 80 : 110,
    slots: { default: 'opt' },
    className: 'col-opt',
  },
  {
    title: that.$l('table_label_originalFileName') || '文件名称',
    field: 'originalFileName',
    minWidth: 300,
    headerAlign: 'center',
    align: 'left',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_uploadBy') || '上传人',
    field: 'uploadBy',
    width: 170,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'uploadInfo' },
  },
  {
    title: that.$l('table_label_processFlag') || '处理状态',
    field: 'processFlag',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'processFlag' },
  },
  {
    title: that.$l('table_label_processDatetime') || '处理时间',
    field: 'processDatetime',
    width: 170,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_processMessage') || '处理结果',
    field: 'processMessage',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'processMessage' },
  },
]
